import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

interface WithNavigationProps {
  showNavigation?: boolean;
}

export const withWebView = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  pageName: string,
  options: { showNavigation?: boolean } = {}
) => {
  return (props: P & WithNavigationProps) => {
    const { lang } = useParams();
    const { t } = useLanguage();
    const { showNavigation = options.showNavigation } = props;
    
    // Auto-detect webview mode from URL if showNavigation is not explicitly set
    const isWebView = showNavigation === undefined 
      ? new URLSearchParams(window.location.search).get('webview') === 'true'
      : !showNavigation;

    return (
      <div className={`${pageName}-page ${isWebView ? 'webview' : ''}`}>
        <WrappedComponent {...props} />
      </div>
    );
  };
}; 